import {
  Box,
  Button,
  CircularProgress,
  Modal,
  Alert as MuiAlert,
  Typography,
} from "@mui/material";

const boxStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 500,
  width: "70%",
  bgcolor: "background.paper",
  border: "2px solid #D32F2F",
  borderRadius: 4,
  boxShadow: 24,
  p: 4,
  textAlign: "center",
};

export interface DemoteResellerModalDelegate {
  onConfirmDemotion: () => void;
  onCloseDemotion: () => void;
}

interface Props {
  isOpen: boolean;
  isLoading: boolean;
  userName: string;
  impactData: { clientsCount: number; activeLicensesCount: number } | null;
  delegate: DemoteResellerModalDelegate;
}

export function DemoteResellerModal({
  isOpen,
  isLoading,
  userName,
  impactData,
  delegate,
}: Props) {
  return (
    <Modal open={isOpen} onClose={delegate.onCloseDemotion}>
      <Box sx={boxStyle}>
        <Typography variant="h5" component="h2" color="error" fontWeight="bold">
          Remover Cargo de Revendedor
        </Typography>
        {isLoading || !impactData ? (
          <Box sx={{ my: 3 }}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Typography sx={{ mt: 2 }}>
              Tem certeza de que deseja remover o cargo de{" "}
              <strong>Revendedor</strong> do usuário <strong>{userName}</strong>
              ?
            </Typography>

            <MuiAlert severity="info" sx={{ mt: 2, textAlign: "left" }}>
              <strong>Importante:</strong> ao confirmar, será apenas removido o
              cargo de Revendedor.
              <ul>
                <li>Dados cadastrais permanecerão intactos;</li>
                <li>Histórico de clientes não será excluído;</li>
                <li>Registros de licenças não serão alterados;</li>
              </ul>
              <Typography variant="body2" sx={{ mt: 1 }}>
                <strong>Para sua informação,</strong> enquanto exerceu esse
                papel, ele acumulou:
                <ul>
                  <li>
                    <strong>{impactData.clientsCount}</strong> clientes
                    vinculados
                  </li>
                  <li>
                    <strong>{impactData.activeLicensesCount}</strong> licenças
                    ativas distribuídas
                  </li>
                </ul>
              </Typography>
            </MuiAlert>
            <Box
              mt={2}
              display="flex"
              flexDirection="row"
              justifyContent="center"
              gap={1}
            >
              <Button
                variant="contained"
                color="error"
                onClick={delegate.onConfirmDemotion}
              >
                Confirmar Remoção
              </Button>
              <Button
                variant="outlined"
                color="error"
                onClick={delegate.onCloseDemotion}
              >
                Cancelar
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
}
